import { c as _c } from "react/compiler-runtime";
import { getRoleMenuItemSx, RoleMenuItem } from "@components/role/role-menu-item";
import { FaroTextMenuButton } from "@components/common/faro-text-menu-button";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { setBulkActionName, updateOne } from "@store/table/table-slice";
import { useEffect, useState } from "react";
import { BulkSuccessDialog } from "@components/common/faro-table/bulk-dialog/bulk-success-dialog";
import { useChangeRoleBulkDialogContent } from "@components/table/members/bulk-actions/bulk-change-role-helper";
import { bulkActionNameSelector, selectedEntitiesSelector, shouldShowSuccessDialogSelector } from "@store/table/table-selector";
import { BulkActionEvents } from "@utils/track-event/track-event-list";
import { updateMemberRoleInGroup } from "@store/groups/groups-slice-thunk";
import { currentUserSelector } from "@store/user/user-selector";
import { FaroBulkDialog } from "@components/common/faro-table/bulk-dialog/bulk-dialog";
import { FaroCoreApiConst } from "@stellar/core-api-client";
import { getBulkActionButtonConfig } from "@components/common/faro-table/bulk-actions/bulk-actions-config";
import { useBulkActionsMode } from "@hooks/use-bulk-actions-mode";
import { Text, UserRoleIcon, MenuItem } from "@flat-ui";

/** Button allowing to change role of members in group */
export function BulkChangeGroupRole(t0) {
  const $ = _c(34);
  const {
    companyId,
    groupId
  } = t0;
  const dispatch = useAppDispatch();
  const [shouldShowDialog, setShouldShowDialog] = useState(false);
  const [newRole, setNewRole] = useState("PROJECT_MANAGER");
  const currentUser = useAppSelector(currentUserSelector);
  const bulkActionName = useAppSelector(bulkActionNameSelector);
  const shouldShowSuccessDialog = useAppSelector(shouldShowSuccessDialogSelector);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = selectedEntitiesSelector("members");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const selectedEntities = useAppSelector(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = selectedEntitiesSelector("teams");
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const selectedTeams = useAppSelector(t2);
  const selectedEntitiesWithoutTeams = selectedEntities.filter(_temp);
  const mode = useBulkActionsMode();
  let t3;
  if ($[2] !== newRole) {
    t3 = {
      subjectType: "group",
      newRole
    };
    $[2] = newRole;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    bulkDialogContent,
    successDialogContent
  } = useChangeRoleBulkDialogContent(t3);
  let t4;
  let t5;
  if ($[4] !== shouldShowSuccessDialog) {
    t4 = () => {
      if (shouldShowSuccessDialog) {
        setShouldShowDialog(false);
      }
    };
    t5 = [shouldShowSuccessDialog];
    $[4] = shouldShowSuccessDialog;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  if ($[7] !== currentUser || $[8] !== dispatch) {
    t6 = function onNewRoleClicked(event) {
      dispatch(setBulkActionName("changeRole"));
      if (currentUser && currentUser.role === "COMPANY_MANAGER") {
        dispatch(updateOne({
          id: currentUser.identity,
          changes: {
            status: "not-allowed",
            message: "Cannot change the role of your user as group manager"
          }
        }));
      }
      setNewRole(event.currentTarget.dataset.myValue);
      setShouldShowDialog(true);
    };
    $[7] = currentUser;
    $[8] = dispatch;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const onNewRoleClicked = t6;
  let t7;
  if ($[10] !== mode) {
    t7 = getBulkActionButtonConfig(mode, "Change role in group");
    $[10] = mode;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const config = t7;
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <UserRoleIcon sx={{
      width: "18px",
      height: "18px"
    }} />;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== config.shouldShowText) {
    t9 = config.shouldShowText ? <Text variant="buttonM">Change role</Text> : undefined;
    $[13] = config.shouldShowText;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const t10 = config.tooltipText;
  let t11;
  if ($[15] !== config.sx) {
    t11 = () => config.sx;
    $[15] = config.sx;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      anchorOrigin: {
        vertical: "top",
        horizontal: "left"
      },
      transformOrigin: {
        vertical: "bottom",
        horizontal: "left"
      }
    };
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  const t13 = config.rippleColor;
  let t14;
  if ($[18] !== onNewRoleClicked) {
    t14 = FaroCoreApiConst.allGroupRoles.map(role => <MenuItem data-my-value={role} key={role} value={role} onClick={onNewRoleClicked} sx={getRoleMenuItemSx({
      isTableCell: false
    })}><RoleMenuItem role={role} /></MenuItem>);
    $[18] = onNewRoleClicked;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== config.rippleColor || $[21] !== config.tooltipText || $[22] !== t11 || $[23] !== t14 || $[24] !== t9) {
    t15 = <FaroTextMenuButton startIcon={t8} buttonTitle={t9} tooltipText={t10} buttonSx={t11} menuPosition={t12} rippleColor={t13} shouldShowEndIcon={false}>{t14}</FaroTextMenuButton>;
    $[20] = config.rippleColor;
    $[21] = config.tooltipText;
    $[22] = t11;
    $[23] = t14;
    $[24] = t9;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== bulkActionName || $[27] !== shouldShowSuccessDialog || $[28] !== successDialogContent) {
    t16 = bulkActionName === "changeRole" && shouldShowSuccessDialog && <BulkSuccessDialog dialogContent={successDialogContent} />;
    $[26] = bulkActionName;
    $[27] = shouldShowSuccessDialog;
    $[28] = successDialogContent;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  const t17 = bulkActionName === "changeRole" && shouldShowDialog && <FaroBulkDialog dialogContent={bulkDialogContent} onClose={() => setShouldShowDialog(false)} trackingEvent={BulkActionEvents.bulkChangeRole} bulkActionCallback={member => dispatch(updateMemberRoleInGroup({
    companyId,
    groupId,
    role: newRole,
    userIdentity: member.identity
  })).unwrap()} selectedEntities={[...selectedEntitiesWithoutTeams, ...selectedTeams]} uniqueIdKey="identity" tableDataType="members" />;
  let t18;
  if ($[30] !== t15 || $[31] !== t16 || $[32] !== t17) {
    t18 = <>{t15}{t16}{t17}</>;
    $[30] = t15;
    $[31] = t16;
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  return t18;
}
function _temp(entities) {
  return entities.kind === "user";
}